/**
 * Swaps the header between the logged-out ("Accedi o registrati") and the
 * logged-in (avatar + profile menu) state, on desktop and on mobile.
 *
 * The four containers live in `partial/_nav.antlers.html`, so they exist only on
 * pages that render the site header. `/booking-online` (and the other pages
 * built on the bare layout) render none of them, and the unguarded
 * `accessContainer.classList` below used to throw
 * `TypeError: Cannot read properties of null (reading 'classList')` there on
 * every single page load — Sentry HUOPENAIR-2P / HUOPENAIR-2T, the two
 * loudest issues on the project. index.js calls this synchronously at import
 * time (`inProgress: true`), so the throw also took down everything after it in
 * that module.
 *
 * Nothing here is a source of truth: with no header on the page there is no UI
 * to switch, so a missing container is a no-op, never an error.
 */
export function renderAuthUI({ isAuthenticated, account }) {
    const accessContainer  = document.getElementById('myhu-access-container');          // non loggato
    const accessContainerMobile  = document.getElementById('myhu-access-container-mobile');   // non loggato
    const profileContainer = document.getElementById('myhu-profile-container');         // loggato
    const profileContainerMobile = document.getElementById('myhu-profile-container-mobile');  // loggato

    // No header on this page (bare layout): nothing to switch.
    if (!accessContainer && !accessContainerMobile && !profileContainer && !profileContainerMobile) {
        return;
    }

    if (isAuthenticated && account) {
        // Show logged-in state
        accessContainer?.classList.add('d-none');
        accessContainerMobile?.classList.add('d-none');
        profileContainer?.classList.remove('d-none');
        profileContainerMobile?.classList.remove('d-none');
        profileContainer?.classList.add('d-flex');
        profileContainerMobile?.classList.add('d-block');

        // Populate avatar initial
        const initials = account.name
            ? account.name.charAt(0).toUpperCase()
            : (account.username?.charAt(0).toUpperCase() ?? '');

        const avatarName = profileContainer?.querySelector('.avatar-name');
        const avatarNameMobile = profileContainerMobile?.querySelector('.avatar-name');
        const greeting   = profileContainer?.querySelector('.popout-header h4');
        const greetingMobile   = profileContainerMobile?.querySelector('h4');

        if (avatarName) avatarName.textContent = initials;
        if (avatarNameMobile) avatarNameMobile.textContent = initials;
        if (greeting)   greeting.textContent   = `Ciao ${account.name?.split(' ')[0] ?? ''}!`;
        if (greetingMobile)   greetingMobile.textContent   = `Ciao ${account.name?.split(' ')[0] ?? ''}!`;

    } else {
        // Show non-logged-in state
        accessContainer?.classList.remove('d-none');
        accessContainerMobile?.classList.remove('d-none');
        profileContainer?.classList.add('d-none');
        profileContainerMobile?.classList.add('d-none');
        profileContainer?.classList.remove('d-flex');
        profileContainerMobile?.classList.remove('d-block');
    }
}
